import { Component, OnInit, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Toast } from 'bootstrap';

@Component({
  selector: 'app-toast-msg',
  imports: [CommonModule, RouterModule],
  standalone: true,
  templateUrl: './toast-msg.component.html',
  styleUrl: './toast-msg.component.scss',
})
export class ToastMsgComponent implements OnInit {
  constructor(private elementRef: ElementRef) {}
  ngOnInit(): void {}
}
